export const fileToDataURL = (file: File) =>
  new Promise((resolve, reject) => {
    // Encode the file using the FileReader API
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
